import React, { useState } from 'react';
import { Row, Col, Card } from 'antd';
import RoleForm from '../components/Role/RoleForm';
import RoleList from '../components/Role/RoleList';
import { Role } from '../types/roles';
import { RoleProvider } from '../store/roleContext';
import { useTranslation } from 'react-i18next';

const RolePage: React.FC = () => {
    const [editRole, setEditRole] = useState<Role | null>(null);
    const { t } = useTranslation();

    return (
        <RoleProvider>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={10} lg={8}>
                  <Card title={editRole ? t('edit_role') : t('add_role')}>
                      <RoleForm editRole={editRole} onFinishEdit={() => setEditRole(null)} />
                  </Card>
              </Col>
                <Col xs={24} md={14} lg={16}>
                  <Card title={t('role_list')}>
                      <RoleList onEdit={setEditRole} />
                  </Card>
              </Col>
          </Row>
      </RoleProvider>
  );
};

export default RolePage;
